import DeviceManager from '../utils/device-manager';

class FloatingCards {
    constructor($floatingCards) {
        const that = this;

        this.$floatingCards = $floatingCards;
        this.$cards = this.$floatingCards.querySelectorAll('.floating-card');
        this.cards = [];
        this.useEvents = false;
        this.$tab = $floatingCards.parentElement;
        this.swiper = null;
        this.$swiperContainer = this.$floatingCards.querySelector('.swiper-container');
        this.$loading = this.$floatingCards.querySelector('.floating-cards-loading');

        this.$loading.parentNode.removeChild(this.$loading);
        this.$swiperContainer.classList.add('initialized');

        if ($floatingCards.classList.contains('js-floating-cards-use-events')) {
            this.useEvents = true;
        }
        
        this.onProfessionalTypeChangeXS = (e) => {
            this.onProfessionalTypeChangeXSHandler(e);
        }

        this.onProfessionalTypeChangeLG = (e) => {
            this.onProfessionalTypeChangeLGHandler(e);
        }

        DeviceManager.addCallback(attr => {
            if (!that.swiper && !DeviceManager.isGreaterThan(attr.current, 'lg')) { // Init Swiper on mobile
                if (that.useEvents) {
                    // First init
                    if (that.$tab.classList.contains('active')) {
                        that.createSwiper();
                    } else {
                        that.destroySwiper();
                    }

                    // Init when event fired
                    document.addEventListener('professionalTypeChanged', that.onProfessionalTypeChangeXS);
                } else {
                    that.createSwiper();
                }
            } else if (that.swiper && DeviceManager.isGreaterThan(attr.current, 'lg')) { // Destroy swipers on desktop
                that.destroySwiper();
                document.removeEventListener('professionalTypeChanged', that.onProfessionalTypeChangeXS);
            }
        });
        
        DeviceManager.addWindowCallback(attr => {
            that.destroyMasonry();
            document.removeEventListener('professionalTypeChanged', that.onProfessionalTypeChangeLG);

            if (DeviceManager.isGreaterThan(attr.current, 'lg')) { // Init masonry in desktop
                if (that.useEvents) {
                    // First init
                    if (that.$tab.classList.contains('active') && !document.body.classList.contains('ie')) {
                        setTimeout(() => {
                            that.createMasonry();
                        }, 1000);
                    }

                    // Init when event fired
                    document.addEventListener('professionalTypeChanged', that.onProfessionalTypeChangeLG);
                } else if (!document.body.classList.contains('ie')) {
                    setTimeout(() => {
                        that.createMasonry();
                    }, 1000);
                }
            }
        });
    }

    onProfessionalTypeChangeXSHandler(e) {
        if (e.detail.tabId === this.$tab.id) {
            this.createSwiper();
        } else {
            this.destroySwiper();
        }
    }

    onProfessionalTypeChangeLGHandler(e) {
        this.destroySwiper();
        this.destroyMasonry();

        if (e.detail.tabId === this.$tab.id && !document.body.classList.contains('ie')) {
            setTimeout(() => {
                this.createMasonry();
            }, 1000);
        }
    }

    createSwiper() {
        let args = {
            slidesPerView: 1,
            spaceBetween: 60,
            threshold: 10,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        };

        const swiper = new Swiper(this.$swiperContainer, args);
        this.swiper = swiper;
    }

    destroySwiper() {
        if (this.swiper) {
            this.swiper.destroy();
            this.swiper = null;
        }

        this.$cards.forEach($card => {
            $card.style.order = $card.dataset.realOrder;
        });
    }

    createMasonry() {
        const nbCardsInFirstCol = Math.ceil(this.$cards.length / 2);

        this.cards = [];

        this.$cards.forEach(($card, i) => {
            $card.querySelector('.floating-card-content-inner').classList.add('close');

            const styles = window.getComputedStyle($card);
            const height = $card.clientHeight + parseInt(styles.marginTop) + parseInt(styles.marginBottom);

            const observer = new IntersectionObserver(entries => {
                if (entries[0]['intersectionRatio'] > 0.6) {
                    $card.classList.add('appear');
                }
            }, { threshold: 0.6 });
            observer.observe($card);

            this.cards.push({
                col: i < nbCardsInFirstCol ? 1 : 2,
                height,
                $card,
                observer,
            });
        });

        const cardHeightCol1 = this.cards.map(attr => attr.col === 1 ? attr.height : 0).reduce((a, b) => a + b); // Sum of all col1 height
        const cardHeightCol2 = this.cards.map(attr => attr.col === 2 ? attr.height : 0).reduce((a, b) => a + b); // Sum of all col2 height

        this.$swiperContainer.style.height = (cardHeightCol1 >= cardHeightCol2 ? cardHeightCol1 : cardHeightCol2) + 20 + 'px'; // 20 = box-shadow
    }

    destroyMasonry() {
        this.$swiperContainer.style.height = '';
        
        this.cards.forEach(attr => {
            attr.$card.classList.remove('appear');
            attr.observer.unobserve(attr.$card);
        });
    }
}

export default FloatingCards;